import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSliceZoomAction } from '../../../redux/slices/FJSliceImageEnhancer.js';
import FJMobileImageEnhancerFooter from './FJMobileImageEnhancerFooter.jsx';
import useLocalStore from '../../../hooks/useLocalStore';
import FJUtil from '../../../util/FJUtil.js';
import FJActionImageEnhancer from '../../../redux/action/FJActionImageEnhancer.js';
import FJActionCommon from '../../../redux/action/FJActionCommon.js';

const FJMobileImageEnhancerFooterContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const upscale = useSelector(state => state.imageEnhancer.upscale);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const creditNumber = useSelector(state => state.common.creditNumber);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const uploadImageList = useSelector(state => state.imageEnhancer.uploadImageList);

    const _onChangeZoom = value => {
        dispatch(setSliceZoomAction(value));
    };
    const uploadImg = useCallback(
        file => {
            dispatch(FJActionImageEnhancer.uploadImagesAction([file]));
        },
        [dispatch],
    );
    const _onGenerate = useCallback(() => {
        if (FJUtil.isGeneratingStatus(taskStatus)) return;
        dispatch(FJActionImageEnhancer.generateAction());
        dispatch(FJActionCommon.setHeaderTabIndexAction(0));
    }, [dispatch, taskStatus]);
    return (
        <FJMobileImageEnhancerFooter
            upscale={upscale}
            onChangeZoom={_onChangeZoom}
            isProjectLoading={isProjectLoading}
            onGenerate={_onGenerate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            creditNumber={creditNumber}
            uploadImageList={uploadImageList}
            uploadImg={uploadImg}
        />
    );
};

export default FJMobileImageEnhancerFooterContainer;
